import './impacts.css'

const impacts = () => {
    return (
        <div className='impacts'>
            <div class="container">
                <h2>Expanding Trade Markets</h2>
                <div class="section-container">
                    <div class="section">
                        <h3>Unlocking Financial Inclusion</h3>
                        <p>SureSend empowers businesses and individuals by providing seamless access to international financial services, ensuring more people can participate in the global economy.</p>
                    </div>
                    <div class="section">
                        <h3>Bridging Markets</h3>
                        <p>Through innovative financial solutions, SureSend connects African markets with the rest of the world, fostering economic growth and international partnerships.</p>
                    </div>
                    <div class="section">
                        <h3>Expanding Trade Opportunities</h3>
                        <p>We streamline cross-border payments, reducing trade barriers and enabling businesses to reach new markets with ease and confidence.</p>
                    </div>
                   
                </div>
            </div>

        </div>
    )
}

export default impacts